import React from 'react';
import { useWallet } from '../../context/WalletContext';
import { ACTIVE_NETWORK } from '../../config/networks';

const NetworkBadge = () => {
  const { account, networkOk, switching } = useWallet();
  if (!account) return null;
  return (
    <div className={`network-badge ${networkOk ? '' : 'bad'}`} title={`Chain ID ${ACTIVE_NETWORK.chainId}`}>
      <span className="ndot" />
      {switching ? '…' : ACTIVE_NETWORK.name}
    </div>
  );
};

export default NetworkBadge;
